import { Button, makeStyles } from '@material-ui/core'
import React from 'react'
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import { useHistory, useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    container: {
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        backgroundColor: theme.palette.primary.main,
        paddingLeft: "5rem",
        paddingRight: "5rem",
        marginTop: "1rem",
        marginBottom: "1rem"
    },
    button: {
        textTransform: "none",
        color: "#ffff"
    }
}));

const BarCartilla = () => {
    const classes = useStyles()
    const history= useHistory()
    const location = useLocation()
    return (
        <div className={classes.container}>
            <Button
                startIcon={location.pathname === "/afiliado/cartilla" ? <FavoriteBorderIcon /> : <FavoriteIcon />}
                className={classes.button}
                onClick={()=>{
                    if(location.pathname === "/afiliado/cartilla"){
                        history.push("/afiliado/mi-cartilla")
                    }else{
                        history.push("/afiliado/cartilla")
                    }
                }}
            >
                Mi Cartilla
            </Button>
        </div>
    )
}

export default BarCartilla